import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { IsOptional, validateIf } from '@pristine-ts/class-validator';
import { CompanyTypeEnum } from '../../../../../enums/company-type.enum';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  CorporateIncomeTaxFederalInCorporateIncomeTaxOptions,
} from '../../../income-tax/corporate/corporate/corporate-income-tax-federal-in-corporate-income-tax.options';
import {
  CorporateIncomeTaxFederalOptions,
} from '../../../income-tax/corporate/federal/corporate-income-tax-federal.options';

@translationBaseKey('corporate-tax-federal-in-salary-dividend-options')
export class CorporateIncomeTaxFederalInSalaryDividendOptions implements Omit<CorporateIncomeTaxFederalInCorporateIncomeTaxOptions,
  'businessIncomeOutsideCanada'> {

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'nonEligibleDividendNonConnected')
  nonEligibleDividendNonConnected: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'eligibleDividendNonConnected')
  eligibleDividendNonConnected: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'capitalGain')
  capitalGain: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'capitalLoss')
  capitalLoss: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'previousIMRTDND')
  @IsOptional()
  previousIMRTDND?: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'previousRTDND')
  @IsOptional()
  previousRTDND?: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'nonEligibleDividendPaid')
  nonEligibleDividendPaid: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'previousIMRTDD')
  @IsOptional()
  previousIMRTDD?: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'previousRTDD')
  @IsOptional()
  previousRTDD?: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'eligibleDividendPaidLastYear')
  @validateIf((object: CorporateIncomeTaxFederalInSalaryDividendOptions, root, currentPath) => {

    if (root.hasOwnProperty('isEligibleDividendMaximized') === false ||
      typeof root['isEligibleDividendMaximized'] !== 'boolean' ||
      root.hasOwnProperty('corporateIncomeTaxOptionsForm') === false ||
      root['corporateIncomeTaxOptionsForm'].hasOwnProperty('companyType') === false
    ) {
      return false;
    }

    const isEligibleDividendMaximized: boolean = root['isEligibleDividendMaximized'];
    const companyType = root['corporateIncomeTaxOptionsForm']['companyType'];

    return companyType === CompanyTypeEnum.ccpcAllYear && isEligibleDividendMaximized;
  })
  eligibleDividendPaidLastYear?: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'gRIPBalance')
  @validateIf((object: CorporateIncomeTaxFederalInSalaryDividendOptions, root, currentPath) => {

    if (root.hasOwnProperty('isEligibleDividendMaximized') === false ||
      typeof root['isEligibleDividendMaximized'] !== 'boolean' ||
      root.hasOwnProperty('corporateIncomeTaxOptionsForm') === false ||
      root['corporateIncomeTaxOptionsForm'].hasOwnProperty('companyType') === false
    ) {
      return false;
    }

    const isEligibleDividendMaximized: boolean = root['isEligibleDividendMaximized'];
    const companyType = root['corporateIncomeTaxOptionsForm']['companyType'];

    return companyType === CompanyTypeEnum.ccpcAllYear && isEligibleDividendMaximized;
  })
  gRIPBalance?: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'eligibleDividendPaid')
  eligibleDividendPaid: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'lRIPBalance')
  @IsOptional()
  lRIPBalance?: number;

  @clonePropertyMetadata<CorporateIncomeTaxFederalOptions>(CorporateIncomeTaxFederalOptions, 'isPartIVTaxUsed')
  isPartIVTaxUsed: boolean;

}
